import CheckboxItem from 'components/Widget/CheckboxItem';
import MultilineInput from 'components/Widget/Input/MultilineInput';
import * as S from './styles';

interface ComposeDrawerProps {
	message: string;
	notify: boolean;
	onMessageChange: (m: string) => void;
	onNotifyChange: (n: boolean) => void;
	disabled?: boolean;
}

const ComposeDrawer = ({
	message,
	notify,
	onMessageChange,
	onNotifyChange,
	disabled,
}: ComposeDrawerProps) => {
	const messageDisabled = disabled || !notify;
	return (
		<S.Base>
			<S.NotifyRow>
				<CheckboxItem
					checked={notify}
					onToggled={() => !disabled && onNotifyChange(!notify)}
					label="Send email notification"
					width={16}
					height={16}
				/>
			</S.NotifyRow>
			<S.MessageGroup $disabled={messageDisabled}>
				<S.Label htmlFor="share-modal-message">Message</S.Label>
				<MultilineInput
					id="share-modal-message"
					value={message}
					placeholder="Add a note (optional)"
					onChange={(e) => onMessageChange(e.target.value)}
					readonly={messageDisabled}
					variant="medium"
					minLines={3}
				/>
			</S.MessageGroup>
		</S.Base>
	);
};

export default ComposeDrawer;
